/**
 * Converts all-day event start/end (stored as UTC instants) to local midnight/end-of-day
 * for the intended calendar date. Use UTC date parts so "Feb 1" displays on Feb 1 in every timezone.
 */
export function allDayToLocalRange(start: Date, end: Date): { start: Date; end: Date } {
  const y = start.getUTCFullYear();
  const m = start.getUTCMonth();
  const d = start.getUTCDate();
  const endY = end.getUTCFullYear();
  const endM = end.getUTCMonth();
  const endD = end.getUTCDate();
  return {
    start: new Date(y, m, d, 0, 0, 0, 0),
    end: new Date(endY, endM, endD, 23, 59, 59, 999),
  };
}

/**
 * Converts a local calendar date to UTC noon for that date.
 * Use when sending all-day meeting/project/task payloads so the backend receives the correct calendar day (e.g. 1 April → 2026-04-01T12:00:00.000Z).
 */
export function allDayToPayloadDate(date: Date): Date {
  const y = date.getFullYear();
  const m = date.getMonth();
  const d = date.getDate();
  return new Date(Date.UTC(y, m, d, 12, 0, 0, 0));
}

/**
 * True when the date is at local midnight (00:00:00.000).
 * Used to detect "date-only" picks that would serialize to the previous day in UTC in some timezones.
 */
export function isLocalMidnight(date: Date): boolean {
  return (
    date.getHours() === 0 &&
    date.getMinutes() === 0 &&
    date.getSeconds() === 0 &&
    date.getMilliseconds() === 0
  );
}
